import React from "react";

import { useHistory } from "react-router-dom";

import { theme } from "@/core/theme";
import { PLATFORM_PROFILE_FORM_URL } from "@/core/urls";
import useDocTitle from "@/hooks/use-doc-title";
import Center from "@/tpo/Center";
import Stack from "@/tpo/Stack";
import B2CHeader from "@/tpo/header/B2CHeader";
import ButtonV2 from "@/v2/Buttons";

import Box from "./Box";
import { CustomerAccountPage } from "./CustomerPage";
import { HeadingMediumLarge } from "./Headings";
import Text from "./Text";

function PlatformProfileWelcomePage() {
  useDocTitle("Welcome");
  const history = useHistory();

  return (
    <>
      <B2CHeader />
      <CustomerAccountPage
        jumbotronProps={{
          title: "Welcome to Regenerus"
        }}
        as={Stack}
        gap={40}
      >
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]} lineHeight="150%">
          At Regenerus we understand that your body is as unique as you are. You therefore deserve
          an approach to health and wellbeing that is tailored specifically to you.
        </Box>
        <Box>
          <HeadingMediumLarge as="h2">Next steps</HeadingMediumLarge>
          <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]} lineHeight="150%" mt="8px">
            The following pages will take you through your account set up.
          </Box>
        </Box>
        <Center>
          <ButtonV2
            withChevron
            color="green"
            width="100%"
            maxWidth={300}
            onClick={() => {
              history.push(PLATFORM_PROFILE_FORM_URL);
            }}
            data-component-name="Complete setup button"
          >
            Complete your setup
          </ButtonV2>
        </Center>
      </CustomerAccountPage>
    </>
  );
}

export default PlatformProfileWelcomePage;
